import apiClient from '../client';
import type { Branch, BranchSchedule, CreateBranchPayload, UpdateBranchPayload } from '@/types';

export const branchesApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get<{ data: Branch[], pagination: { total: number } }>('/branches', { params }).then((r) => r.data),

  getById: (id: number) =>
    apiClient.get<{ data: Branch }>(`/branches/${id}`).then((r) => r.data.data),

  create: (payload: CreateBranchPayload) =>
    apiClient.post<{ data: Branch }>('/branches', payload).then((r) => r.data.data),

  update: (id: number, payload: UpdateBranchPayload) =>
    apiClient.put<{ data: Branch }>(`/branches/${id}`, payload).then((r) => r.data.data),

  remove: (id: number) =>
    apiClient.delete(`/branches/${id}`),

  // ── Branch schedule (instructional-days config) ─────────────────────────
  getSchedule: (slug: string) =>
    apiClient.get<{ data: BranchSchedule }>(`/branches/${slug}/schedule`).then((r) => r.data.data),

  updateSchedule: (slug: string, payload: BranchSchedule) =>
    apiClient.put<{ data: BranchSchedule }>(`/branches/${slug}/schedule`, payload).then((r) => r.data.data),
};
